export default __webpack_public_path__ + "static/media/router.8f68c635.svg";